/* eslint-disable max-lines */
import { selectAllUsers, selectUsers } from 'actions/userPermissionsPage';
import FilterListHeaderRedesign from 'components/Filters/FilterListHeaderRedesign';
import Tooltip from 'components/Tooltip';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getSelectedUsers } from 'selectors/userPermissionsPage';
import { getUsers } from 'selectors/users';
import { useSelector } from 'store';

const LLUsersHeaders: React.FC = () => {
  const dispatch = useDispatch();

  const users = useSelector(getUsers);
  const selectedUsers = useSelector(getSelectedUsers);

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.checked) {
      dispatch(selectUsers(Object.values(users)));
      dispatch(selectAllUsers(true));
    } else {
      dispatch(selectUsers([]));
      dispatch(selectAllUsers(false));
    }
  };

  return (
    <thead className="sticky top-0 z-10">
      <tr className="table-wrapper__header-tr h-10">
        <th className="table-wrapper__new-th table-wrapper__th--w-3">
          <div className="px-2">
            <Tooltip tooltip="envelopesListActions.selectAll" redesign>
              <label
                htmlFor="select-all"
                className="flex justify-start items-center w-full cursor-pointer"
              >
                <input
                  id="select-all"
                  data-testid="select-all"
                  className={`cursor-pointer form-checkbox litlingo-checkbox w-5 h-5 rounded-sm ${
                    selectedUsers.length > 0 && selectedUsers?.length < Object.keys(users).length
                      ? 'checkbox-select-all-partial'
                      : ''
                  }`}
                  type="checkbox"
                  checked={
                    selectedUsers?.length === Object.keys(users).length && selectedUsers?.length > 0
                  }
                  onChange={handleSelectAll}
                />
              </label>
            </Tooltip>
          </div>
        </th>
        <FilterListHeaderRedesign
          resource={resourceQueryParamName.user}
          text="Name"
          field="name"
          className="table-wrapper__new-th"
        />
        <th className="table-wrapper__new-th table-wrapper__th--w-20">Email</th>
        <th className="table-wrapper__new-th table-wrapper__th--w-24">Role</th>
        <th className="table-wrapper__new-th table-wrapper__th--w-16">Division</th>
        <th className="table-wrapper__new-th table-wrapper__th--w-16">Region</th>
      </tr>
    </thead>
  );
};
export default LLUsersHeaders;
